import React, { useEffect, useState } from "react";
import { ReactComponent as QuestionMark } from "assets/icons/question_mark.svg";
import { ReactComponent as QuestionMarkRounded } from "assets/icons/question_mark_rounded.svg";
import { ReactComponent as DeleteIcon } from "assets/icons/delete.svg";
import property from "assets/images/property.jpeg";
import useProperties from "hooks/useProperties";
import { formatCurrency } from "utils/formatNumber";
import RemoveWarningDialog from "components/Dialog/RemoveWarningDialog";
import AnimatedDialogLayout from "components/Dialog/AnimatedDialogLayout";
import SearchCard from "components/Card/SearchCard";
import useAuth from "hooks/useAuth";
import { useMediaQuery } from "react-responsive";
import { useOrganiseList } from "context/OrganiseListContext";
import PropertyPopup from "components/Dialog/PropertyPopup";

const DoubtProperties = () => {
  const {
    doubtProperties,
    isLoadingDoubt,
    fetchDoubtProperties,
    removeDoubtProperty,
    setSelectedPropertyPopup,
    selectedPropertyPopup,
  } = useProperties();
  const { setIsDoubtPropertiesActive, isDoubtPropertiesActive } =
    useOrganiseList();
  const isPopulateProperty = true; // Fetch list with populate property
  const [doubtPropertyRemovePopupOpen, setDoubtPropertyRemovePopupOpen] =
    useState(null);
  const isMobile = useMediaQuery({ query: "(max-width: 500px)" });
  const { user } = useAuth();

  useEffect(() => {
    fetchDoubtProperties(isPopulateProperty);
  }, [user]);

  const handleRemoveConfirm = async () => {
    await removeDoubtProperty(doubtPropertyRemovePopupOpen);
    setDoubtPropertyRemovePopupOpen(null);
  };

  const toggleDoubtPropertyList = () => {
    document.body.style.overflow = "hidden";
    setIsDoubtPropertiesActive(!isDoubtPropertiesActive);
  };

  return (
    <div className="bg-white w-full flex flex-col lg:w-[44%] h-[552px] rounded-[15px] px-[15px] md:px-[18px] pb-[18px] pt-[16px] ">
      <div className="px-[2px] flex items-start xs:items-center justify-between">
        <div className="flex items-center space-x-[15px]">
          <div className="bg-[#E8F6FF] flex-shrink-0 w-[52px] h-[52px] rounded-full flex items-center justify-center">
            <QuestionMark />
          </div>
          <h1 className="text-[16px] leading-[19.36px] md:text-[22px] font-semibold line-clamp-3 md:leading-[30px] text-black">
            Ancora in dubbio su
            <br /> queste proprietà?
          </h1>
        </div>
        {(isMobile ? doubtProperties?.results?.length > 0 : true) && (
          <button
            onClick={toggleDoubtPropertyList}
            className="border bg-primary text-white flex-shrink-0 border-primary rounded-[8px] hover:bg-primary hover:text-white transition-all duration-200 ease-in px-[10px] h-[31px] text-[12px] font-medium"
          >
            Vai alla Lista
          </button>
        )}
      </div>
      <div className="mt-[19px] flex flex-grow flex-col gap-y-[6px] overflow-y-auto">
        {doubtProperties?.results?.length > 0 ? (
          doubtProperties?.results?.map((property) => (
            <div
              key={property?._id}
              className="h-[83px] bg-[#F8F8F8] border border-[#E8E8E8] rounded-[5px] py-[7px] pl-[14px] pr-[8px] flex space-x-3 sm:space-x-[15px] items-end"
              onClick={() =>
                setSelectedPropertyPopup({
                  property: {
                    ...property?.propertyId,
                    average_gross_yield: property?.averageGrossYield,
                  },
                  id: "doubtProperty",
                })
              }
            >
              <div className="w-[45%] pb-1">
                <h1 className="text-[15px] line-clamp-1 font-medium leading-[28px] text-black">
                  {property?.propertyId?.title}
                </h1>
                <p className="text-[#9B9B9B] font-light text-[12px] leading-[12px]">
                  {property?.propertyId?.location?.name}
                </p>
                <h4 className="text-[12px] leading-[12px] mt-[6px] font-semibold text-black">
                  {formatCurrency(
                    property?.propertyId?.sale_price,
                    property?.propertyId?.sale_currency
                  )}
                </h4>
              </div>
              <div className="w-[55%] flex items-center space-x-2 sm:space-x-[15px] h-full">
                <div className="w-full h-full relative">
                  <img
                    src={property?.propertyId?.pictures[0]}
                    alt="property"
                    className="w-full h-full rounded-[7px] object-cover"
                  />
                </div>
                <div className="bg-primary  rounded-[5px] flex-shrink-0 min-w-[42px] h-full flex flex-col items-center space-y-[14px] justify-between py-[11px]">
                  <QuestionMarkRounded className="cursor-pointer text-white" />
                  <DeleteIcon
                    onClick={() =>
                      setDoubtPropertyRemovePopupOpen(property?.propertyId?._id)
                    }
                    className="cursor-pointer stroke-white"
                  />
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="flex h-full items-center justify-center flex-col">
            <QuestionMarkRounded
              width={100}
              height={100}
              className=" text-[#1DA1F266]"
            />
            <p className="text-[16px] text-center mt-4 font-semibold leading-[20px] text-[#A5D9FA]">
              Nessuna proprietà aggiunta alla lista dubbi
            </p>
          </div>
        )}
      </div>

      <RemoveWarningDialog
        warningText={"Are you sure you want to remove it from doubt list?"}
        isOpen={doubtPropertyRemovePopupOpen}
        isClose={() => setDoubtPropertyRemovePopupOpen(null)}
        onClick={handleRemoveConfirm}
      />
      {/* Property card on click mini cell*/}
      <PropertyPopup popupType="doubtProperty" isOrganisePage={true} />
    </div>
  );
};

export default DoubtProperties;
